import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { supabase } from '../supabaseClient';

export const fetchBasketTopics = createAsyncThunk(
  'basket/fetchBasketTopics',
  async (basketId) => {
    const { data, error } = await supabase
      .from('topics')
      .select('*, tags(*), concepts(*)')
      .eq('basket_id', basketId);

    if (error) throw error;
    return data;
  }
);

const basketSlice = createSlice({
  name: 'basket',
  initialState: {
    currentBasket: null,
    status: 'idle',
    error: null,
  },
  reducers: {
    setCurrentBasket: (state, action) => {
      state.currentBasket = action.payload;
    },
    updateBasketTopics: (state, action) => {
      if (state.currentBasket) {
        state.currentBasket.topics = action.payload;
      }
    },
    removeTopicFromCurrentBasket: (state, action) => {
      if (state.currentBasket && state.currentBasket.topics) {
        state.currentBasket.topics = state.currentBasket.topics.filter(
          topic => topic.id !== action.payload
        );
      }
    },
    addTopicToCurrentBasket: (state, action) => {
      if (state.currentBasket) {
        const topicExists = state.currentBasket.topics.some(topic => topic.id === action.payload.id);
        if (!topicExists) {
          state.currentBasket.topics.unshift(action.payload);
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBasketTopics.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchBasketTopics.fulfilled, (state, action) => {
        state.status = 'succeeded';
        if (state.currentBasket) {
          state.currentBasket.topics = action.payload;
        }
      })
      .addCase(fetchBasketTopics.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export const { 
  updateBasketTopics, 
  removeTopicFromCurrentBasket,
  addTopicToCurrentBasket
} = basketSlice.actions;

export default basketSlice.reducer;